export default __webpack_public_path__ + "static/media/Tarakror1.74d1cd47.png";